export const END_POINTS = {
  AUTH: {
    LOGIN: "auth/user/login",
    USER_PROFILE: "user/profile",
    REGISTRATION: "auth/register",
    CHECK_USERNAME: (name: string) => `auth/username/check/${name}`,
    CHECK_EMAIL: (email: string) => `auth/email/check/${email}`,
    OTP_VERIFY: "auth/verify-otp",
    FORGOT_PASSWORD: "auth/forgot-password/email",
    FORGOT_PASSWORD_OTP: "auth/forgot-password/otp",
    CHANGE_PASSWORD: "auth/change-password",
    RESEND_OTP: "auth/send-otp",
    GET_REFERRAL_CODE: (id: string) => `auth/referral/code/${id}`,
  },

  //DASHBOARD
  DASHBOARD: {
    INFO: "user/dashboard",
    WITHDRAW_LIST: "user/withdrawal-request",
    FETCH_LEVEL: "user/level",
  },

  //wallet
  WALLET_INVESTMENT: "user/wallet-address/investment",
  WALLET_EARNING: "user/wallet-address/earning",

  //reward
  REWARD_LIST: "user/level",
  REWARD_CLAIM: (levelId: string, levelTypeId: string) =>
    `user/level/claim/${levelId}/${levelTypeId}`,

  //regerral
  REFERRAL: "user/referral-code",
  REFERRAL_LIST: "user/referrals",

  //currency
  CURRENCY_LIST: "user/currency-chain",

  //deposit
  DEPOSIT: "user/deposit-request",

  //withdraw
  WITHDRAW: "user/withdrawal-request",

  //third party control
  THIRD_PARTY_ADDRESS: (id?: string) =>
    `user/third-party-address${id ? "/" + id : ""}`,
};
